import { AutogenModelEdiPartner, AutogenRowEdiPartner } from "./autogen/AutogenModelEdiPartner";

export class ModelEdiPartner extends AutogenModelEdiPartner<RowEdiPartner> {
	constructor() {
		super(RowEdiPartner);
	}
}

export class RowEdiPartner extends AutogenRowEdiPartner {
}